{
  "15852ba9fdafaa1c": "Download the Clipboard Workplace Mobile App",
  "28d03596d24eeb4e": "Skip",
  "355f5e74848522db": "iOS",
  "358a97b9bb66c070": "Failed to update. Please try again.",
  "3d56ae33bf72d534": "What types of shifts do you want to post first?",
  "5256900289c82266": "Invite Staff",
  "5cff875ddac5c777": "See what else you can do",
  "6a58cf22edab0bf9": "Post your staffing needs",
  "6a9e16f0fb0cd7ae": "Invite Professionals You Know to Join Clipboard with You!",
  "6d612a86bee4b0a6": "Android",
  "7be9efc23bd18b68": "offer a block of shifts",
  "8640d6e1e13d439c": "You posted your first staffing request!",
  "981038b9aea98b69": "Invite staff",
  "983f311018642b0a": "Get Started",
  "9ceda19cf812ec8a": "Post your first shift",
  "aa26583ec8dbfb73": "Here's how to get started...",
  "ac70249101626e2d": "Fill your shifts with trusted professionals",
  "ad1e8b5af91b0b2e": "IntermediateShiftPostingModal",
  "b7b7cd05c471d63b": "Post more shifts",
  "d3159e27a9330927": "Post shifts",
  "e789a9857da6e2b1": "You can invite staff to join Clipboard anytime!",
  "eeeef2e208677554": "Manage your schedule, post shifts, and message workers on the go.",
  "efd29d8c54d0a8ff": "Take Clipboard with you"
}
